function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_28193_31691)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M44.0658 36.2046C43.4222 36.5391 42.7584 36.8334 42.0783 37.0859C39.925 37.8873 37.6447 38.2939 35.3471 38.2859C26.4783 38.2859 18.7533 32.1921 18.7533 24.3546C18.7649 23.3051 19.0558 22.2777 19.5963 21.378C20.1368 20.4783 20.9072 19.7389 21.8283 19.2359C13.8033 19.5734 11.7408 27.9359 11.7408 32.8296C11.7408 46.7046 24.5096 48.0921 27.2658 48.0921C28.7471 48.0921 30.9783 47.6609 32.3283 47.2296L32.5721 47.1546C37.7385 45.3692 42.1427 41.8775 45.0596 37.2546C45.1444 37.1141 45.1807 36.9498 45.1632 36.7866C45.1456 36.6235 45.075 36.4707 44.9622 36.3515C44.8494 36.2324 44.7007 36.1535 44.5388 36.1269C44.3769 36.1004 44.2108 36.1277 44.0658 36.2046Z",
  fill: "url(#paint0_linear_28193_31691)"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.35,
  d: "M44.0658 36.2046C43.4222 36.5391 42.7584 36.8334 42.0783 37.0859C39.925 37.8873 37.6447 38.2939 35.3471 38.2859C26.4783 38.2859 18.7533 32.1921 18.7533 24.3546C18.7649 23.3051 19.0558 22.2777 19.5963 21.378C20.1368 20.4783 20.9072 19.7389 21.8283 19.2359C13.8033 19.5734 11.7408 27.9359 11.7408 32.8296C11.7408 46.7046 24.5096 48.0921 27.2658 48.0921C28.7471 48.0921 30.9783 47.6609 32.3283 47.2296L32.5721 47.1546C37.7385 45.3692 42.1427 41.8775 45.0596 37.2546C45.1444 37.1141 45.1807 36.9498 45.1632 36.7866C45.1456 36.6235 45.075 36.4707 44.9622 36.3515C44.8494 36.2324 44.7007 36.1535 44.5388 36.1269C44.3769 36.1004 44.2108 36.1277 44.0658 36.2046Z",
  fill: "url(#paint1_radial_28193_31691)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.5533 45.7296C18.8843 44.693 17.4377 43.3356 16.2971 41.7359C14.9946 39.9531 14.098 37.9069 13.6703 35.7408C13.2426 33.5748 13.2941 31.3414 13.8211 29.1973C14.3482 27.0533 15.3381 25.0505 16.7214 23.3297C18.1046 21.6088 19.8477 20.2115 21.8283 19.2359C22.4283 18.9546 23.4221 18.4671 24.7533 18.4859C25.6901 18.4931 26.6125 18.7169 27.4484 19.1397C28.2844 19.5626 29.0112 20.173 29.5721 20.9234C30.3265 21.9379 30.74 23.1654 30.7533 24.4296C30.7533 24.3921 35.3471 9.50461 15.7533 9.50461C7.52206 9.50461 0.753315 17.3046 0.753315 24.1671C0.720575 27.7921 1.49559 31.379 3.02207 34.6671C5.52195 39.9903 9.88932 44.2103 15.2951 46.5261C20.7009 48.8419 26.7689 49.0922 32.3471 47.2296C30.3928 47.8468 28.3278 48.0324 26.2948 47.7734C24.2617 47.5144 22.3092 46.8171 20.5721 45.7296H20.5533Z",
  fill: "url(#paint2_linear_28193_31691)"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.41,
  d: "M20.5533 45.7296C18.8843 44.693 17.4377 43.3356 16.2971 41.7359C14.9946 39.9531 14.098 37.9069 13.6703 35.7408C13.2426 33.5748 13.2941 31.3414 13.8211 29.1973C14.3482 27.0533 15.3381 25.0505 16.7214 23.3297C18.1046 21.6088 19.8477 20.2115 21.8283 19.2359C22.4283 18.9546 23.4221 18.4671 24.7533 18.4859C25.6901 18.4931 26.6125 18.7169 27.4484 19.1397C28.2844 19.5626 29.0112 20.173 29.5721 20.9234C30.3265 21.9379 30.74 23.1654 30.7533 24.4296C30.7533 24.3921 35.3471 9.50461 15.7533 9.50461C7.52206 9.50461 0.753315 17.3046 0.753315 24.1671C0.720575 27.7921 1.49559 31.379 3.02207 34.6671C5.52195 39.9903 9.88932 44.2103 15.2951 46.5261C20.7009 48.8419 26.7689 49.0922 32.3471 47.2296C30.3928 47.8468 28.3278 48.0324 26.2948 47.7734C24.2617 47.5144 22.3092 46.8171 20.5721 45.7296H20.5533Z",
  fill: "url(#paint3_radial_28193_31691)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.3096 28.3859C29.1409 28.5734 28.6721 28.8546 28.6721 29.4359C28.6721 29.9234 28.9909 30.4109 29.5721 30.8046C32.2534 32.6796 37.3346 32.4171 37.3534 32.4171C39.3522 32.4158 41.3141 31.8784 43.0346 30.8609C44.7668 29.8477 46.204 28.3994 47.2038 26.6596C48.2037 24.9197 48.7314 22.9488 48.7346 20.9421C48.7909 16.7421 47.2346 13.9484 46.6159 12.7109C42.6221 4.94835 34.0534 0.485855 24.7346 0.485855C18.4275 0.485232 12.3736 2.96741 7.88227 7.39555C3.39098 11.8237 0.823313 17.8418 0.734619 24.1484C0.828369 17.3046 7.63462 11.7734 15.7346 11.7734C16.3909 11.7734 20.1409 11.8296 23.6096 13.6484C26.0466 14.8593 28.0647 16.7729 29.4034 19.1421C30.5471 21.1296 30.7534 23.6609 30.7534 24.6734C30.7534 25.6859 30.2471 27.1671 29.2909 28.4046L29.3096 28.3859Z",
  fill: "url(#paint4_radial_28193_31691)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.3096 28.3859C29.1409 28.5734 28.6721 28.8546 28.6721 29.4359C28.6721 29.9234 28.9909 30.4109 29.5721 30.8046C32.2534 32.6796 37.3346 32.4171 37.3534 32.4171C39.3522 32.4158 41.3141 31.8784 43.0346 30.8609C44.7668 29.8477 46.204 28.3994 47.2038 26.6596C48.2037 24.9197 48.7314 22.9488 48.7346 20.9421C48.7909 16.7421 47.2346 13.9484 46.6159 12.7109C42.6221 4.94835 34.0534 0.485855 24.7346 0.485855C18.4275 0.485232 12.3736 2.96741 7.88227 7.39555C3.39098 11.8237 0.823313 17.8418 0.734619 24.1484C0.828369 17.3046 7.63462 11.7734 15.7346 11.7734C16.3909 11.7734 20.1409 11.8296 23.6096 13.6484C26.0466 14.8593 28.0647 16.7729 29.4034 19.1421C30.5471 21.1296 30.7534 23.6609 30.7534 24.6734C30.7534 25.6859 30.2471 27.1671 29.2909 28.4046L29.3096 28.3859Z",
  fill: "url(#paint5_radial_28193_31691)"
}));
var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_28193_31691",
  x1: 11.7408,
  y1: 33.6734,
  x2: 45.1908,
  y2: 33.6734,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#0C59A4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#114A8B"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint1_radial_28193_31691",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(30.2096 33.9255) scale(17.8875 16.9931)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.7,
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9,
  stopOpacity: 0.5
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_28193_31691",
  x1: 29.3658,
  y1: 19.1609,
  x2: 8.49706,
  y2: 41.9046,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#1B9DE2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2,
  stopColor: "#1595DF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7,
  stopColor: "#0680D7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#0078D4"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint3_radial_28193_31691",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(13.9636 37.7865) rotate(-81.3844) scale(26.8849 21.7203)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9,
  stopOpacity: 0.5
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint4_radial_28193_31691",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(5.58899 9.3576) rotate(92.2906) scale(37.9803 80.8903)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#35C1F1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.1,
  stopColor: "#34C1ED"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2,
  stopColor: "#2FC2DF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3,
  stopColor: "#2BC3D2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7,
  stopColor: "#36C752"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint5_radial_28193_31691",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(45.7459 14.9796) rotate(73.7398) scale(18.2437 14.8358)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#66EB6E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#66EB6E",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_28193_31691"
}, /*#__PURE__*/React.createElement("rect", {
  width: 48,
  height: 48,
  fill: "white",
  transform: "translate(0.734619 0.485855)"
})));
function SvgEdge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdge);
export default __webpack_public_path__ + "static/media/edge.2d0f6d53d020bff288f3d38fddbe2df9.svg";
export { ForwardRef as ReactComponent };